//
// Importação dos componentes da pasta.
//

const filepaths = require.context(
  // Pasta de pesquisa...
  '.',
  // Varrer sub-pastas?
  true,
  // Padrão de nome dos arquivos de componentes...
  /Pagelet[\w-]+\.vue$/
)

const components = {}

filepaths.keys().forEach((filepath) => {
  const sourceCode = filepaths(filepath)

  if (!sourceCode.default)
    return

  const aliases = [
    filepath.split('/')
      // Pegando o nome do arquivo
      .slice(-1).pop()
      // Removendo a extensão
      .replace(/\.\w+$/, '')
  ]

  if (sourceCode.default.aliases) {
    sourceCode.default.aliases.forEach(alias => aliases.push(alias))
  }

  aliases.forEach(alias => components[alias] = sourceCode.default)
})

export default components
